import { useState, useEffect } from 'react';
import api from '../../api';

function formatDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('uk-UA', { day:'2-digit', month:'2-digit', year:'numeric' });
}
function formatDateTime(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('uk-UA', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
}
function calcAge(birth_date) {
  if (!birth_date) return null;
  return Math.floor((Date.now() - new Date(birth_date)) / (1000*60*60*24*365.25));
}
function toInputDate(iso) {
  if (!iso) return '';
  return iso.slice(0, 10);
}

export default function CustomerDetail({ customer, onUpdated, onDeleted }) {
  const [transactions, setTransactions] = useState([]);
  const [bonusForm, setBonusForm] = useState({ amount:'', description:'' });
  const [editInfo, setEditInfo] = useState(false);
  const [infoForm, setInfoForm] = useState({ full_name:'', phone:'' });
  const [editBirthDate, setEditBirthDate] = useState(false);
  const [birthDateValue, setBirthDateValue] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteInput, setDeleteInput] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!customer) return;
    setError(''); setSuccess('');
    setEditInfo(false);
    setInfoForm({ full_name: customer.full_name||'', phone: customer.phone||'' });
    setEditBirthDate(false);
    setBirthDateValue(toInputDate(customer.birth_date));
    setShowDeleteConfirm(false);
    setDeleteInput('');
    api.get(`/customers/${customer.id}/transactions`)
      .then(r => setTransactions(r.data))
      .catch(() => setTransactions([]));
  }, [customer?.id]);

  async function adjustBonus(e) {
    e.preventDefault(); setError(''); setSuccess('');
    try {
      const res = await api.post(`/customers/${customer.id}/bonus`, bonusForm);
      onUpdated(res.data);
      setBonusForm({ amount:'', description:'' });
      const txRes = await api.get(`/customers/${customer.id}/transactions`);
      setTransactions(txRes.data);
      setSuccess('Бонуси оновлено!');
    } catch(err) { setError(err.response?.data?.detail || 'Помилка'); }
  }

  async function saveInfo() {
    try {
      const res = await api.patch(`/customers/${customer.id}`, {
        full_name: infoForm.full_name || null,
        phone: infoForm.phone,
      });
      onUpdated(res.data);
      setEditInfo(false);
      setSuccess('Дані клієнта збережено!');
    } catch(err) { setError(err.response?.data?.detail || 'Помилка'); }
  }

  async function saveBirthDate() {
    try {
      const res = await api.patch(`/customers/${customer.id}`, {
        birth_date: birthDateValue ? new Date(birthDateValue).toISOString() : null,
      });
      onUpdated(res.data);
      setEditInfo(false);
    setInfoForm({ full_name: customer.full_name||'', phone: customer.phone||'' });
    setEditBirthDate(false);
      setSuccess('Дату народження збережено!');
    } catch(err) { setError(err.response?.data?.detail || 'Помилка'); }
  }

  async function toggleBlacklist() {
    const res = await api.patch(`/customers/${customer.id}`, {
      is_blacklisted: !customer.is_blacklisted,
      blacklist_reason: customer.is_blacklisted ? null : 'Заблоковано адміністратором',
    });
    onUpdated(res.data);
  }

  async function toggleAgeVerified() {
    const res = await api.patch(`/customers/${customer.id}`, { age_verified: !customer.age_verified });
    onUpdated(res.data);
  }

  async function deleteCustomer() {
    try {
      await api.delete(`/customers/${customer.id}`);
      onDeleted(customer.id);
    } catch(err) { setError(err.response?.data?.detail || 'Помилка видалення'); }
  }

  const deleteConfirmWord = customer?.phone?.slice(-4) || '0000';

  if (!customer) return (
    <div style={styles.empty}>
      <div style={{fontSize:'64px', marginBottom:'16px'}}>👆</div>
      <p>Оберіть клієнта зі списку</p>
    </div>
  );

  return (
    <div style={styles.wrap}>
      {/* Шапка */}
      <div style={styles.header}>
        <div style={styles.avatar}>
          {customer.full_name?.[0]?.toUpperCase() || customer.phone[0]}
        </div>
        <div style={{flex:1}}>
          {!editInfo ? (
            <>
              <h2 style={styles.name}>{customer.full_name || 'Без імені'}
                <button style={styles.editInfoBtn} onClick={() => setEditInfo(true)}>✏️</button>
              </h2>
              <div style={styles.phoneRow}>
                <span style={styles.phone}>{customer.phone}</span>
                <button style={styles.editInfoBtn} onClick={() => setEditInfo(true)}>✏️</button>
              </div>
            </>
          ) : (
            <div style={styles.infoEditBox}>
              <div style={styles.infoEditField}>
                <label style={styles.infoEditLabel}>Ім'я</label>
                <input style={styles.infoEditInput} placeholder="Ім'я клієнта"
                  value={infoForm.full_name} autoFocus
                  onChange={e => setInfoForm(f => ({...f, full_name: e.target.value}))} />
              </div>
              <div style={styles.infoEditField}>
                <label style={styles.infoEditLabel}>Телефон</label>
                <input style={styles.infoEditInput} placeholder="+380..."
                  value={infoForm.phone}
                  onChange={e => setInfoForm(f => ({...f, phone: e.target.value}))} />
              </div>
              <div style={styles.infoEditBtns}>
                <button style={styles.saveDateBtn} onClick={saveInfo}>✓ Зберегти</button>
                <button style={styles.cancelDateBtn} onClick={() => setEditInfo(false)}>Скасувати</button>
              </div>
            </div>
          )}

          {/* Дата народження */}
          <div style={styles.birthRow}>
            {!editBirthDate ? (
              <>
                <span style={styles.meta}>
                  {customer.birth_date
                    ? `🎂 ${formatDate(customer.birth_date)} (${calcAge(customer.birth_date)} років)`
                    : '🎂 Дата народження не вказана'}
                </span>
                <button style={styles.editDateBtn} onClick={() => setEditBirthDate(true)}>
                  ✏️
                </button>
              </>
            ) : (
              <div style={styles.editDateRow}>
                <input style={styles.dateInput} type="date"
                  value={birthDateValue}
                  onChange={e => setBirthDateValue(e.target.value)} />
                <button style={styles.saveDateBtn} onClick={saveBirthDate}>✓</button>
                <button style={styles.cancelDateBtn} onClick={() => {
                  setEditInfo(false);
    setInfoForm({ full_name: customer.full_name||'', phone: customer.phone||'' });
    setEditBirthDate(false);
                  setBirthDateValue(toInputDate(customer.birth_date));
                }}>✕</button>
              </div>
            )}
          </div>

          <div style={styles.regDate}>Клієнт з {formatDate(customer.created_at)}</div>

          {customer.store_ids?.length > 0 && (
            <div style={styles.storeTags}>
              {customer.store_ids.map(s => (
                <span key={s.id} style={styles.storeTag}>🏪 {s.name}</span>
              ))}
            </div>
          )}
        </div>
        <div style={styles.balanceBox}>
          <div style={styles.balanceNum}>{parseFloat(customer.bonus_balance).toFixed(2)}</div>
          <div style={styles.balanceLabel}>бонусів</div>
        </div>
      </div>

      {success && <p style={styles.success}>{success}</p>}

      {/* Статуси */}
      <div style={styles.statusRow}>
        <button style={customer.age_verified ? styles.btnActive : styles.btn} onClick={toggleAgeVerified}>
          {customer.age_verified ? '✅ Вік підтверджено' : '❓ Вік не перевірено'}
        </button>
        <button style={customer.is_blacklisted ? styles.btnBlack : styles.btn} onClick={toggleBlacklist}>
          {customer.is_blacklisted ? '🚫 В чорному списку' : '➕ Чорний список'}
        </button>
        <button style={styles.btnDelete} onClick={() => setShowDeleteConfirm(true)}>
          🗑 Видалити
        </button>
      </div>
      {customer.is_blacklisted && <p style={styles.blackReason}>Причина: {customer.blacklist_reason}</p>}

      {/* Підтвердження видалення */}
      {showDeleteConfirm && (
        <div style={styles.deleteBox}>
          <div style={styles.deleteTitle}>⚠️ Видалення клієнта</div>
          <p style={styles.deleteText}>
            Це незворотня дія. Всі бонуси та історія транзакцій будуть видалені.
            Введіть останні 4 цифри телефону <strong style={{color:'#ff6b6b'}}>{deleteConfirmWord}</strong> для підтвердження:
          </p>
          <div style={styles.deleteRow}>
            <input style={styles.deleteInput}
              placeholder={`Введіть ${deleteConfirmWord}`}
              value={deleteInput}
              onChange={e => setDeleteInput(e.target.value)} />
            <button
              style={{...styles.confirmDeleteBtn, opacity: deleteInput === deleteConfirmWord ? 1 : 0.4}}
              disabled={deleteInput !== deleteConfirmWord}
              onClick={deleteCustomer}>
              Видалити назавжди
            </button>
            <button style={styles.cancelDeleteBtn} onClick={() => { setShowDeleteConfirm(false); setDeleteInput(''); }}>
              Скасувати
            </button>
          </div>
          {error && <p style={styles.error}>{error}</p>}
        </div>
      )}

      {/* Бонуси */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Коригування бонусів</h3>
        <form onSubmit={adjustBonus} style={styles.bonusForm}>
          <input style={styles.bonusInput} type="number" step="0.01"
            placeholder="Сума (+ або -)" value={bonusForm.amount}
            onChange={e => setBonusForm({...bonusForm, amount:e.target.value})} required />
          <input style={styles.bonusInput} placeholder="Причина"
            value={bonusForm.description}
            onChange={e => setBonusForm({...bonusForm, description:e.target.value})} required />
          <button type="submit" style={styles.bonusBtn}>Застосувати</button>
        </form>
        {!showDeleteConfirm && error && <p style={styles.error}>{error}</p>}
      </div>

      {/* Транзакції */}
      <div style={styles.section}>
        <h3 style={styles.sectionTitle}>Історія бонусів ({transactions.length})</h3>
        {transactions.length === 0 ? <p style={styles.hint}>Транзакцій поки не було</p> : (
          <div style={styles.txList}>
            {transactions.map(t => (
              <div key={t.id} style={styles.txRow}>
                <span style={parseFloat(t.amount) > 0 ? styles.txPlus : styles.txMinus}>
                  {parseFloat(t.amount) > 0 ? '+' : ''}{parseFloat(t.amount).toFixed(2)}
                </span>
                <span style={styles.txDesc}>{t.description}</span>
                <span style={styles.txDate}>{formatDateTime(t.created_at)}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  wrap: { flex:1, overflowY:'auto', padding:'20px 24px' },
  empty: { flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', color:'#9a8a6e' },
  header: { display:'flex', alignItems:'flex-start', gap:'14px', marginBottom:'16px', background:'#211c14', borderRadius:'12px', padding:'16px', border:'1px solid #38301f' },
  avatar: { width:'48px', height:'48px', borderRadius:'50%', background:'#1c1812', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'20px', fontWeight:'bold', color:'#f5a623', flexShrink:0 },
  name: { margin:'0 0 4px', fontSize:'18px' },
  phone: { color:'#9a8a6e', fontSize:'14px', marginBottom:'6px' },
  birthRow: { display:'flex', alignItems:'center', gap:'8px', marginBottom:'4px' },
  meta: { color:'#9a8a6e', fontSize:'12px' },
  editInfoBtn: { background:'transparent', border:'none', cursor:'pointer', fontSize:'13px', paddingLeft:'5px', color:'#9a8a6e' },
  editDateBtn: { background:'transparent', border:'none', cursor:'pointer', fontSize:'13px', padding:'0', color:'#9a8a6e' },
  editDateRow: { display:'flex', alignItems:'center', gap:'6px' },
  dateInput: { padding:'4px 8px', borderRadius:'6px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'13px' },
  saveDateBtn: { padding:'4px 10px', background:'#2d6a4f', color:'#5fbf8f', border:'none', borderRadius:'6px', cursor:'pointer', fontWeight:'bold' },
  cancelDateBtn: { padding:'4px 10px', background:'rgba(255,107,107,.18)', color:'#ff6b6b', border:'none', borderRadius:'6px', cursor:'pointer' },
  regDate: { color:'#9a8a6e', fontSize:'11px', marginBottom:'6px' },
  storeTags: { display:'flex', flexWrap:'wrap', gap:'6px', marginTop:'4px' },
  storeTag: { background:'#1c1812', border:'1px solid #38301f', color:'#6cb6ff', padding:'2px 10px', borderRadius:'12px', fontSize:'12px' },
  balanceBox: { textAlign:'center', background:'#1c1812', borderRadius:'10px', padding:'10px 14px', flexShrink:0 },
  balanceNum: { fontSize:'22px', fontWeight:'bold', color:'#f5a623' },
  balanceLabel: { fontSize:'11px', color:'#9a8a6e' },
  statusRow: { display:'flex', gap:'8px', marginBottom:'8px', flexWrap:'wrap' },
  btn: { padding:'7px 14px', background:'#38301f', color:'#9a8a6e', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'12px' },
  btnActive: { padding:'7px 14px', background:'#2d6a4f', color:'#5fbf8f', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'12px' },
  btnBlack: { padding:'7px 14px', background:'rgba(255,107,107,.18)', color:'#ff6b6b', border:'none', borderRadius:'8px', cursor:'pointer', fontSize:'12px' },
  btnDelete: { padding:'7px 14px', background:'transparent', color:'#ff6b6b', border:'1px solid rgba(255,107,107,.18)', borderRadius:'8px', cursor:'pointer', fontSize:'12px', marginLeft:'auto' },
  blackReason: { color:'#ff6b6b', fontSize:'12px', marginBottom:'12px' },
  deleteBox: { background:'#1a0a0a', border:'1px solid #ff6b6b', borderRadius:'10px', padding:'16px', marginBottom:'16px' },
  deleteTitle: { color:'#ff6b6b', fontWeight:'bold', fontSize:'15px', marginBottom:'8px' },
  deleteText: { color:'#9a8a6e', fontSize:'13px', lineHeight:'1.6', marginBottom:'12px' },
  deleteRow: { display:'flex', gap:'8px', flexWrap:'wrap', alignItems:'center' },
  deleteInput: { padding:'8px 12px', borderRadius:'7px', border:'1px solid #ff6b6b', background:'#0f0000', color:'#fff', fontSize:'13px', width:'120px' },
  confirmDeleteBtn: { padding:'8px 16px', background:'#ff6b6b', color:'#1a0a0a', border:'none', borderRadius:'7px', fontWeight:'bold', cursor:'pointer', fontSize:'13px' },
  cancelDeleteBtn: { padding:'8px 16px', background:'transparent', color:'#9a8a6e', border:'1px solid #38301f', borderRadius:'7px', cursor:'pointer', fontSize:'13px' },
  section: { background:'#211c14', borderRadius:'12px', padding:'16px', border:'1px solid #38301f', marginBottom:'12px' },
  sectionTitle: { color:'#f5a623', margin:'0 0 12px', fontSize:'15px' },
  bonusForm: { display:'flex', gap:'8px', flexWrap:'wrap' },
  bonusInput: { flex:1, minWidth:'120px', padding:'8px 12px', borderRadius:'8px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'13px' },
  bonusBtn: { padding:'8px 16px', background:'#f5a623', color:'#14110c', border:'none', borderRadius:'8px', fontWeight:'bold', cursor:'pointer' },
  error: { color:'#ff6b6b', fontSize:'12px', marginTop:'6px' },
  success: { color:'#5fbf8f', fontSize:'13px', margin:'0 0 12px', padding:'8px 12px', background:'#0d2818', borderRadius:'8px' },
  txList: { display:'flex', flexDirection:'column', gap:'5px' },
  txRow: { display:'flex', alignItems:'center', gap:'8px', padding:'8px 10px', background:'#1c1812', borderRadius:'7px' },
  txPlus: { color:'#5fbf8f', fontWeight:'bold', fontSize:'13px', minWidth:'50px' },
  txMinus: { color:'#ff6b6b', fontWeight:'bold', fontSize:'13px', minWidth:'50px' },
  txDesc: { flex:1, fontSize:'12px', color:'#cbd5e0' },
  txDate: { color:'#9a8a6e', fontSize:'11px', whiteSpace:'nowrap' },
  hint: { color:'#9a8a6e', textAlign:'center', padding:'16px' },
};
